﻿import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserSharedService } from './user-shared.service';

@Injectable()
export class UserAuthenticateGuard implements CanActivate, CanActivateChild {

    constructor(private _sharedSerive: UserSharedService) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        //var subject = new Subject<boolean>();
        console.log("canActivate" + this._sharedSerive.userDetails.Email);
        if (this._sharedSerive.userDetails && this._sharedSerive.userDetails.Email && this._sharedSerive.userDetails.Email !="") {
            return of(true);
        }
        else {
            //console.log("CanActivateViaAuthGuard Activate");
            return of(false);
        };

    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        //this.authService._app.ActiveSubModule = SubModuleEnum.;
        return this.canActivate(route, state);
    }
}